import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import FormFooter from '../../../components/form-footer';
import IntakeBackgroundScreeningSocialMediaFields from '../../../components/intake/background-screening/social-media-fields';
import { updateActiveFormBackgroundScreeningSocialMedia, selectActiveFormBackgroundScreeningSocialMedia, selectActiveFormBackgroundScreeningDetails } from '../../../reducers/active-form-slice';
import BackgroundScreeningSocialMediaSchema from '../../../validation-schemas/background-screening-social-media-schema';
import FormHeaderButtons from '../form-header-buttons';
import { hasNonBlankValues } from '../../../utility/has-values';

const IntakeBackgroundScreeningSocialMedia = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();


    /**
     * get current form values
     */
    const backgroundScreeningSocialMedia = useSelector(selectActiveFormBackgroundScreeningSocialMedia);
    const backgroundScreeningSubject = useSelector(selectActiveFormBackgroundScreeningDetails);

    const hasValues = hasNonBlankValues(backgroundScreeningSocialMedia);


    /**
     * handle the previous button
     */
    const handlePrevious = () => {
        navigate("/intake/background-screening/details");
    };


    /**
     * update active form & continue
     */
    const handleSubmit = (values) => {
        dispatch(updateActiveFormBackgroundScreeningSocialMedia(values));
        navigate("/intake/additional-information");
    };

    /**
     * handle save for later
     */
    const handleSaveForLater = (values) => {
        dispatch(updateActiveFormBackgroundScreeningSocialMedia(values));
    };

    /**
     * setup the initial values
     */
    const initialValues = {
        socialMediaFirstName: backgroundScreeningSubject.firstName,
        socialMediaLastName: backgroundScreeningSubject.lastName,
        socialMediaEmail: backgroundScreeningSubject.emailPrimary,
        socialMediaPhone: backgroundScreeningSubject.phonePrimary,
        socialMediaAddress: backgroundScreeningSubject.address,
        socialMediaAddress2: backgroundScreeningSubject.address2,
        socialMediaCity: backgroundScreeningSubject.city,
        socialMediaStateProvince: backgroundScreeningSubject.stateProvince,
        socialMediaZip: backgroundScreeningSubject.zip,
        socialMediaCountry: backgroundScreeningSubject.country,
        socialMediaLocations: '',
        socialMediaConnectionsAssociates: '',
        socialMediaConnectionsAssociatesLocations: '',
        socialMediaUsername: '',
        socialMediaVin: backgroundScreeningSubject.vin,
        socialMediaLicensePlate: backgroundScreeningSubject.licensePlate,
        socialMediaKeyword: '',
        socialMediaJob: backgroundScreeningSubject.jobs,
        socialMediaDob: backgroundScreeningSubject.dob,
        socialMediaAge: backgroundScreeningSubject.age,
        socialMediaSchool: '',
        socialMediaDateOfIncident: '',
    };


    return (
        <div className="page intake">
            <Formik
                initialValues={hasValues ? backgroundScreeningSocialMedia : initialValues}
                validationSchema={BackgroundScreeningSocialMediaSchema.fields.backgroundScreeningSocialMedia}
                onSubmit={handleSubmit}
            >
                {({ errors, dirty, isValid, touched, values }) => (
                    <Form>
                        <div className="form-header-buttons">
                            <div>
                                <h2>Social Media Subject Search Details</h2>
                                <p>FILL WITH “N/A” IF NOT APPLICABLE ON REQUIRED FIELDS</p>
                            </div>
                            <FormHeaderButtons updateForm={() => handleSaveForLater(values)}/>
                        </div>

                        <IntakeBackgroundScreeningSocialMediaFields
                            errors={errors}
                            touched={touched}
                            values={values}
                        />

                        <FormFooter
                            handlePrevious={handlePrevious}
                            showPrevious={true}
                            disableNext={!((dirty || hasValues) && isValid)}
                            showNext={true}
                            progress={`75`}
                        />
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default IntakeBackgroundScreeningSocialMedia;